var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Subject as SubjectModel } from '@/models/Subject';
import PageHeader from '@/components/page-header/PageHeader';
import ErrorHandler from '@/support/ErrorHandler';
import { excludeRoles } from '@/support/ExcludeRoles';
import Summary from '@/views/Subjects/Summary';
import Templates from '@/views/Subjects/Templates';
import Notes from '@/views/Subjects/Notes';
import FileUpload from '@/views/Subjects/FileUpload';
import Messages from '@/views/Subjects/Messages';
import Worksheet from '@/views/Subjects/Worksheet';
let Subject = class Subject extends Vue {
    constructor() {
        super(...arguments);
        this.subject = null;
        this.activeTab = 'tab-notes';
    }
    mounted() {
        this.initialize();
    }
    async initialize() {
        if (this.$route.query.tab) {
            this.activeTab = `tab-${this.$route.query.tab}`;
        }
        if (!this.id) {
            return;
        }
        this.fetchSubject();
    }
    onSubjectSelected(subject) {
        const query = Object.assign({}, this.$route.query);
        this.$router.push({ path: `/subjects/${subject && subject.id || ''}`, query });
        this.fetchSubject(subject.id);
    }
    async fetchSubject(id) {
        try {
            this.subject = await new SubjectModel().include(['chat', 'curriculum', 'description', 'level', 'period', 'children', 'meta', 'parent', 'subject_labels']).find(id ? id : this.id);
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    get breadcrumbs() {
        return [
            { name: this.$tc('library.title'), path: '/curricula' },
            {
                name: this.subject.curriculum.name || '',
                path: '/curricula/' + this.subject.curriculum.id,
            },
            { name: this.subject && this.subject.name || '', path: this.$route.path },
        ];
    }
    get isTopic() {
        return !!this.subject && this.subject.isTopic;
    }
    get isSubject() {
        return !!this.subject && this.subject.isSubject;
    }
    get isWorksheetEnabled() {
        if (this.subject && this.subject.parent && typeof this.subject.parent !== 'string' && this.subject.parent.parent && typeof this.subject.parent.parent !== 'string' && this.subject.parent.parent.has_generated_worksheets) {
            return true;
        }
        return false;
    }
    get id() {
        return this.subjectParam && this.subjectParam.id ? this.subjectParam.id : this.$route.params.id;
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], Subject.prototype, "subjectParam", void 0);
Subject = __decorate([
    Component({
        components: {
            PageHeader,
            Summary,
            Templates,
            Notes,
            FileUpload,
            Messages,
            Worksheet,
        },
    })
], Subject);
export default Subject;
